module.exports = {"title":"History","cost_value":"Values"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/history.php
// module id = HlhP
// module chunks = 1